// React.
import React from 'react';

// Components.
import AddVendorForm from '../vendor/AddVendorForm';

// Material UI.
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

// Styles.
import { useStyles } from './AddVendorStyles';

// Translations.
import { useTranslation } from 'react-i18next';

const AddVendor = () => {
  const classes = useStyles();
  const [t] = useTranslation('global');

  return (
    <Paper className={classes.paper} elevation={4} square={false} variant="elevation">
      <Typography color="primary"  variant="h5" align="inherit">
        <AddCircleOutlineIcon/> { t('vendors.add-vendor-title') }
      </Typography>
      <br/>
      <AddVendorForm/>
    </Paper>
  )
}

export default AddVendor;
